/* eslint-disable no-console */
//import { observable, computed, action, runInAction } from "mobx";
import { OTPClient } from 'services';
import { RootStore } from 'store';
import BaseStore from './baseStore';
import { observable, action } from 'mobx';
import { parseBadRequestError } from 'utils';

export class OTPStore extends BaseStore {
	private _otpClient: OTPClient;

	private static OTP_STORAGE_KEY = 'cachedOtp';

	@observable isAwaitingOTP: boolean = false;
	@observable otp: string = '';
	@observable sentViaEmail: boolean = false;
	@observable task: Function = () => {};

	constructor(root: RootStore) {
		super(root);
		this._otpClient = new OTPClient(this.API_URL);
		// Hydrate OTP from sessionStorage so it survives page refresh
		this.otp = sessionStorage.getItem(OTPStore.OTP_STORAGE_KEY) || '';
	}

	reset() {
		this.isAwaitingOTP = false;
		this.task = () => {};
		this.loading = false;
	}

	@action clearOtp() {
		this.otp = '';
		sessionStorage.removeItem(OTPStore.OTP_STORAGE_KEY);
	}

	@action async SendOtp(otp: string) {
		// save this otp so that we can use it when people scroll to next page
		this.otp = otp;
		sessionStorage.setItem(OTPStore.OTP_STORAGE_KEY, otp);
		this.task(otp);
		this.reset();
	}

	@action async SendSignupOtp(number: string) {
		this.loading = true;

		this.AuthorisedRequest(this._otpClient, async () => {
			try {
				await this._otpClient.create(number);
				this.loading = false;
			} catch (e) {
				this._rootStore.submitExceptionToAppInsight(e);
				this.error = parseBadRequestError(e) || 'Error sending OTP. Please try again later';
				this.loading = false;
			}
		});
	}

	@action async TriggerOTP(callback: Function) {
		this.loading = true;
		this.sentViaEmail = false;
		this.AuthorisedRequest(this._otpClient, async () => {
			try {
				await this._otpClient.create('');
				this.isAwaitingOTP = true;
				this.task = callback;
			} catch (e) {
				this._rootStore.submitExceptionToAppInsight(e);
				this.loading = false;
				this.error = parseBadRequestError(e) || 'Error sending OTP. Please try again later';
			}
		});
	}

	@action async TriggerOTPEmail(callback: Function) {
		this.loading = true;
		this.sentViaEmail = true;
		this.AuthorisedRequest(this._otpClient, async () => {
			try {
				await this._otpClient.otpViaEmail('');
				this.isAwaitingOTP = true;
				this.task = callback;
			} catch (e) {
				this._rootStore.submitExceptionToAppInsight(e);
				this.loading = false;
				this.error = parseBadRequestError(e) || 'Error sending OTP. Please try again later';
			}
		});
	}

  @action async ResendOTPViaEmail(callback: Function) {
    this.loading = true;
    this.sentViaEmail = true;
    this.AuthorisedRequest(this._otpClient, async () => {
      try {
        await this._otpClient.resendOTPViaEmail();
        this.isAwaitingOTP = true;
        this.task = callback;
      } catch (e) {
        this._rootStore.submitExceptionToAppInsight(e);
        this.loading = false;
        this.error = parseBadRequestError(e) || 'Error sending OTP. Please try again later';
      }
    });
  }

	@action cancelOtp() {
		this.reset();
	}
}

export default OTPStore;
